import Vue from 'vue/dist/vue.esm';
import VueSwal from 'vue-swal/dist/vue-swal';
import BootstrapVue from 'bootstrap-vue';
import toastr from '@v2/atoms/clinic/WideToastr.vue';
// 事前問診詳細のフッター
import Footer from '@/components/clinic/questionnaire/footer.vue';
import NormalButton from '@/components/common/button/normal-button.vue';
import ModalButton from '@/components/common/button/modal-button.vue';
import PrimaryButton from '@/components/common/button/primary-button.vue';
import PrimaryButtonIcon from '@/components/common/button/primary-button-icon.vue';
import PrimaryUserButton from '@/components/common/button/primary-user-button.vue';
import NormalSquareIconButton from '@/components/common/button/normal-square-icon-button.vue';
import NormalSquareIconButton02 from '@/components/common/button/normal-square-icon-button02.vue';

import QuoteButton from '@/components/common/button/quote-button.vue';

// 病院側のテキストエリア
import ClinicTextArea from '@/components/common/textarea/clinic-textarea.vue';
import PulldownButton from '@/components/common/button/pulldown-button.vue';
// 病院側のアドバイス一覧
import AdvicesYearSelect from '@/components/clinic/advices-year-select.vue';
// 病院側の個別メッセージ新規作成・編集
import CustomerSearch from '@/components/clinic/message/customer-search.vue';
// 病院側の受付項目選択
import ReceptionItemSelect from '@/components/clinic/shared/reception-item/reception-item-select.vue';

import BackButton from '@/components/common/button/back-button.vue';
import HeaderTitle from '@/components/common/text/header-title.vue';
import HeaderFullscreenTitle from '@/components/common/text/header-fullscreen-title.vue';
import CloseButton from '@/components/common/button/close-button.vue';
// 病院側のお知らせプレビュー
import PostPreviewCloseButton from '@/components/preview/button/post-preview-close-button.vue';
import AlertMessage from '@/components/alert/alert-message.vue';
import ModalHeaderTitle from '@/components/modal/modal-header-title.vue';
import Tabs from '@/components/modal/tabs.vue';
import ModalBodyDetailRow from '@/components/modal/modal-body-detail-row.vue';
import ModalBodyDetailLinkRow from '@/components/modal/modal-body-detail-link-row.vue';
// 病院側のお知らせテンプレート
import ModalTemplateBody from '@/components/modal/clinic/news/modal-template-body.vue';
// 病院側のお知らせテンプレート（引用ボタン）
import ModalTemplateQuoteButton from '@/components/modal/clinic/common/button/modal-template-quote-button.vue';
// 病院側の個別メッセージテンプレート
import MessageModalTemplateBody from '@/components/modal/clinic/message/message-modal-template-body.vue';
// 病院側の個別メッセージテンプレート（引用ボタン）
import MessageModalTemplateQuoteButton from '@/components/modal/clinic/common/button/message-modal-template-quote-button.vue';

import ModalBodyDateMessage from '@/components/modal/modal-body-date-message.vue';
import ExternalLink from '@/components/common/text/external-link-text.vue';
import Link from '@/components/common/text/link-text.vue';
import ContentDetailTextRow from '@/components/content-detail/content-detail-text-row.vue';
import ContentDetailTextWithIconRow from '@/components/content-detail/content-detail-text-with-icon-row.vue';
import ContentDetailBetweenRow from '@/components/content-detail/content-detail-between-row.vue';
import ContentDetailBetweenTitleBoldRow from '@/components/content-detail/content-detail-between-title-bold-row.vue';
import ContentDetailTwoColumnTwoRow from '@/components/content-detail/content-detail-two-column-two-row.vue';
import ContentDetailImage from '@/components/content-detail/content-detail-image.vue';
import ContentDetailImageRow from '@/components/content-detail/content-detail-image-row.vue';
import ContentDetailLinkArrowRow from '@/components/content-detail/content-detail-link-arrow-row.vue';
import ContentDetailLinkTextArrowRow from '@/components/content-detail/content-detail-link-text-arrow-row.vue';
import ContentDetailNotice from '@/components/content-detail/content-detail-notice.vue';
import ContentFormBox from '@/components/content-form/content-form-box.vue';
import ContentFormPatientCardNumberBox from '@/components/content-form/content-form-patient-card-number-box.vue';
import ContentFormRemarkBox from '@/components/content-form/content-form-remark-box.vue';
import ContentFormMemoBox from '@/components/content-form/content-form-memo-box.vue';
import SelectBox from '@/components/common/select/select-box.vue';
import LabelText from '@/components/common/text/label-text.vue';
import LabelText2 from '@/components/common/text/label-text2.vue';

import BadgeSquare from '@/components/common/text/badge-square.vue';

import PrimaryText from '@/components/common/text/primary-text.vue';
import PrimaryTextarea from '@/components/common/text/primary-textarea.vue';
import TitleText from '@/components/common/text/title-text.vue';
import TitleText2 from '@/components/common/text/title-text2.vue';
import ContentDetailRow from '@/components/content-detail/content-detail-row.vue';

import ContentDetailList from '@/components/content-detail/content-detail-list.vue';
import ContentDetailList2 from '@/components/content-detail/content-detail-list2.vue';

import NormalText from '@/components/common/text/normal-text.vue';
import NormalText2 from '@/components/common/text/normal-text2.vue';
import NormalBlockText from '@/components/common/text/normal-block-text.vue';
import NormalBlockText2 from '@/components/common/text/normal-block-text2.vue';
import ContentHomeNavItem from '@/components/content-home/content-home-nav-item.vue';
import ContentHomeNavItem2 from '@/components/content-home/content-home-nav-item2.vue';
// 病院側のお知らせプレビュー
import NewsPreview from '@/components/preview/news/preview.vue';
// 病院側の個別メッセージプレビュー
import MessagePreview from '@/components/preview/message/preview.vue';

import ArrowRight from '@/components/common/utility/arrow-right.vue';
import ClipRight from '@/components/common/utility/clip-right.vue';

import SidebarMenuItem from '@/components/clinic/shared/sidebar/sidebar-menu-item.vue';
import SidebarSubmenu from '@/components/clinic/shared/sidebar/sidebar-submenu.vue';
import SidebarSubmenuItem from '@/components/clinic/shared/sidebar/sidebar-submenu-item.vue';
import SidebarMenuButton from '@/components/clinic/shared/sidebar/menu-button.vue';

import PrimaryCheckbox from '@/components/common/checkbox/primary-checkbox.vue';
import PrimaryRadioButton from '@/components/common/radio/primary-radio-button.vue';

import QuestionnairesAllRead from '@v2/organisms/clinic/questionnaires/AllRead.vue';
import QuestionnairesReadIcon from '@v2/atoms/clinic/icon/QuestionnairesReadIcon.vue';

import { eventBus, action } from '@/utility/event-bus';
import { setupViewport } from '@/utility/viewport';

import PickupAdContainer from '@v2/organisms/clinic/pickup_ads/Container.vue';

// Vuesセットアップ
import Vuex from 'vuex';
import pickupAd from '@v2/store/modules/common/pickupAd';
import questionnaire from '@v2/store/modules/clinic/questionnaire';
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    pickupAd,
    questionnaire,
  },
});

// Register global vue custom components
Vue.component('AppNormalButton', NormalButton);
Vue.component('AppModalButton', ModalButton);
Vue.component('AppPrimaryButton', PrimaryButton);
Vue.component('AppPrimaryButtonIcon', PrimaryButtonIcon);
Vue.component('AppPrimaryUserButton', PrimaryUserButton);
Vue.component('AppNormalSquereIconButton', NormalSquareIconButton);
Vue.component('AppNormalSquereIconButton02', NormalSquareIconButton02);
// 病院側の病院側の事前問診返信用メッセージテンプレート（引用ボタン）
Vue.component('AppQuoteButton', QuoteButton);
// 病院側のお知らせテンプレート（引用ボタン）
Vue.component('AppModalTemplateQuoteButton', ModalTemplateQuoteButton);
// 病院側の個別メッセージテンプレート（引用ボタン）
Vue.component('AppMessageModalTemplateQuoteButton', MessageModalTemplateQuoteButton);
// 病院側のテキストエリア
Vue.component('AppClinicTextarea', ClinicTextArea);
Vue.component('AppPulldownButton', PulldownButton);
Vue.component('AppSelectBox', SelectBox);
Vue.component('AppExternalLink', ExternalLink);
Vue.component('AppLink', Link);
Vue.component('AppBackButton', BackButton);
Vue.component('AppNormalText', NormalText);
Vue.component('AppNormalText2', NormalText2);
Vue.component('AppLabelText', LabelText);
Vue.component('AppLabelText2', LabelText2);
Vue.component('AppBadgeSquare', BadgeSquare);
Vue.component('AppNormalBlockText', NormalBlockText);
Vue.component('AppNormalBlockText2', NormalBlockText2);
Vue.component('AppHeaderTitle', HeaderTitle);
Vue.component('AppHeaderFullscreenTitle', HeaderFullscreenTitle);
Vue.component('AppPrimaryText', PrimaryText);
Vue.component('AppPrimaryTextarea', PrimaryTextarea);
Vue.component('AppTitleText', TitleText);
Vue.component('AppCloseButton', CloseButton);
Vue.component('AppPrimaryCheckbox', PrimaryCheckbox);
Vue.component('AppPrimaryRadioButton', PrimaryRadioButton);
// 病院側のお知らせプレビュー
Vue.component('AppPostPreviewCloseButton', PostPreviewCloseButton);
// 事前問診の一括既読ボタン
Vue.component('AppQuestionnairesAllRead', QuestionnairesAllRead);
// 事前問診の既読マーク
Vue.component('AppQuestionnairesReadIcon', QuestionnairesReadIcon);

// Register global vue plugins
Vue.use(BootstrapVue);
Vue.use(VueSwal);

document.addEventListener('DOMContentLoaded', () => {
  setupViewport();

  const USER_COLLAPSED_MENU_KEY = 'user-collapsed-sidebar';
  new Vue({
    el: '#sidebar',
    store,
    components: {
      SidebarMenuItem,
      SidebarSubmenu,
      SidebarSubmenuItem,
      SidebarMenuButton,
    },
    data() {
      return {
        isUserCollapsed: null,
        isSmallScreen: false,
      };
    },
    computed: {
      isCollapsed() {
        if (this.isUserCollapsed !== null) {
          return this.isUserCollapsed;
        }
        return this.isSmallScreen;
      },
    },
    watch: {
      isUserCollapsed(to) {
        this.saveUserCollapsed(to);
      },
    },
    created() {
      this.loadUserCollapsed();
    },
    mounted() {
      this.onResize();
      window.addEventListener('resize', this.onResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.onResize);
    },
    methods: {
      saveUserCollapsed(value) {
        localStorage.setItem(USER_COLLAPSED_MENU_KEY, value);
      },
      loadUserCollapsed() {
        const isUserCollapsed = localStorage.getItem(USER_COLLAPSED_MENU_KEY);
        if (isUserCollapsed !== null) {
          this.isUserCollapsed = isUserCollapsed === 'true';
        }
      },
      toggleCollapsed() {
        const isCollapsed = !this.isCollapsed;
        this.isUserCollapsed = isCollapsed;
        eventBus.toggleCollapsed(action.TOGGLE_COLLAPSED);
      },
      onResize() {
        this.isSmallScreen = Math.min(window.screen.width, window.innerWidth) <= 1024;
      },
    },
  });

  new Vue({
    el: '#content-area',
    store,
    components: {
      // 病院側のお知らせプレビュー
      appNewsPreivew: NewsPreview,
      // 病院側の個別メッセージプレビュー
      appMessagePreivew: MessagePreview,
      // 病院側のアドバイス一覧
      appAdvicesYearSelect: AdvicesYearSelect,
      // 病院側の個別メッセージ新規作成・編集
      appCustomerSearch: CustomerSearch,
      // 病院側の受付項目選択
      appReceptionItemSelect: ReceptionItemSelect,
      appAlertMessage: AlertMessage,
      appModalHeaderTitle: ModalHeaderTitle,
      appModalBodyDetailRow: ModalBodyDetailRow,
      appModalBodyDetailLinkRow: ModalBodyDetailLinkRow,
      // 病院側のお知らせテンプレート
      appModalTemplateBody: ModalTemplateBody,
      // 病院側の個別メッセージテンプレート
      appMessageModalTemplateBody: MessageModalTemplateBody,
      appModalBodyDateMessage: ModalBodyDateMessage,
      appTabs: Tabs,
      appContentFormBox: ContentFormBox,
      appContentFormPatientCardNumberBox: ContentFormPatientCardNumberBox,
      appContentFormRemarkBox: ContentFormRemarkBox,
      appContentFormMemoBox: ContentFormMemoBox,
      appTitleText2: TitleText2,
      appContentDetailTextRow: ContentDetailTextRow,
      appContentDetailTextWithIconRow: ContentDetailTextWithIconRow,
      appContentDetailBetweenRow: ContentDetailBetweenRow,
      appContentDetailBetweenTitleBoldRow: ContentDetailBetweenTitleBoldRow,
      appContentDetailTwoColumnTwoRow: ContentDetailTwoColumnTwoRow,
      appContentDetailImage: ContentDetailImage,
      appContentDetailImageRow: ContentDetailImageRow,
      appContentDetailLinkArrowRow: ContentDetailLinkArrowRow,
      appContentDetailLinkTextArrowRow: ContentDetailLinkTextArrowRow,
      appContentDetailNotice: ContentDetailNotice,

      appContentDetailRow: ContentDetailRow,

      appContentDetailList: ContentDetailList,
      appContentDetailList2: ContentDetailList2,

      appArrowRight: ArrowRight,
      appClipRight: ClipRight,

      appFooter: Footer,
      appContentHomeNavItem: ContentHomeNavItem,
      appContentHomeNavItem2: ContentHomeNavItem2,
      appPickupAdContainer: PickupAdContainer,
    },
    data() {
      return {
        items: [],
        message_quote: document.querySelector("[v-model='message_quote']")
          ? document.querySelector("[v-model='message_quote']").value
          : '',
        temp_message_quote: '',
        temp_news_quote: '',
        // FIXME: 「病院からのお知らせ」編集画面に現在のデータを表示する処理が共通ファイルにあるので別の箇所に移動したい
        news_from_clinic: {
          title: document.querySelector('#data-news_from_clinic-title')
            ? document.querySelector('#data-news_from_clinic-title').getAttribute('data-value')
            : '',
          body: document.querySelector('#data-news_from_clinic-body')
            ? document.querySelector('#data-news_from_clinic-body').getAttribute('data-value')
            : '',
          external_link_message: document.querySelector('#data-news_from_clinic-external_link_message')
            ? document
                .querySelector('#data-news_from_clinic-external_link_message')
                .getAttribute('data-value')
            : '',
          external_link_url: document.querySelector('#data-news_from_clinic-external_link_url')
            ? document
                .querySelector('#data-news_from_clinic-external_link_url')
                .getAttribute('data-value')
            : '',
        },
        message: {
          body: document.querySelector('#data-message-body')
            ? document.querySelector('#data-message-body').getAttribute('data-value')
            : '',
        },
        clinic_advice: {
          body: document.querySelector('#data-clinic_advice-body')
            ? document.querySelector('#data-clinic_advice-body').getAttribute('data-value')
            : '',
        },
      };
    },
    created() {
      // 病院側の事前問診返信用メッセージテンプレート(本文を選択したタイミングで実行)
      eventBus.$on(action.MESSAGE_QUOTE, (message) => {
        this.temp_message_quote = message;
      });

      // 病院側の事前問診返信用メッセージテンプレート(「引用」ボタンをクリックしたタイミングで実行)
      eventBus.$on(action.DECIDE_QUOTE, () => {
        this.message_quote = this.temp_message_quote;
      });

      // 病院側のお知らせテンプレート(本文を選択したタイミングで実行)
      eventBus.$on(action.TEMPLATE_NEWS_QUOTE, (news) => {
        this.temp_news_quote_title = news['title'];
        this.temp_news_quote_body = news['body'];
        // 引用するボタンにクラス追加
        $('.template-modal__deside').addClass('template-modal__deside--push');
      });

      // 病院側のお知らせテンプレート(「引用する」ボタンをクリックしたタイミングで実行)
      eventBus.$on(action.DECIDE_TEMPLATE_NEWS_QUOTE, () => {
        this.news_from_clinic.title = this.temp_news_quote_title;
        this.news_from_clinic.body = this.temp_news_quote_body;

        const targetImage = $('[name="radio_images"]:checked').val();
        if (targetImage !== undefined) {
          const imageAttribute = targetImage.split(',');
          if (imageAttribute.length == 2) {
            $('#js-image').html(`<img src="${imageAttribute[1]}" />`);
            $('#news_from_clinic_attachment_template_id').val(imageAttribute[0]);
          }
        }
      });

      // 病院側の個別メッセージテンプレート(本文を選択したタイミングで実行)
      eventBus.$on(action.TEMPLATE_MESSAGE_QUOTE, (message) => {
        this.temp_message_quote_body = message['body'];
        // 引用するボタンにクラス追加
        $('.template-modal__deside').addClass('template-modal__deside--push');
      });

      // 病院側の個別メッセージテンプレート(「引用する」ボタンをクリックしたタイミングで実行)
      eventBus.$on(action.DECIDE_TEMPLATE_MESSAGE_QUOTE, () => {
        this.message.body = this.temp_message_quote_body;

        let targetImage = $('[name="radio_images"]:checked').val();
        if (targetImage !== undefined) {
          let imageAttribute = targetImage.split(',');
          if (imageAttribute.length == 2) {
            $('.js-clinic-message-image').html(`<img src="${imageAttribute[1]}" />`);
            $('#message_attachment_template_id').val(imageAttribute[0]);
          }
        }
      });
    },
    methods: {
      showToast() {
        toastr.info('トースト表示テスト');
      },
      // 病院側のお知らせプレビュー
      showPostPreview() {
        eventBus.showPostPreview();
      },
    },
  });
});
